import { booleanAttribute, ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { EzRouterLinkDirective } from 'src/shared/directives/ez-router-link.directive';
import { materialModules } from 'src/shared/material.module';
import { globalWindow } from 'src/shared/window-globals';

@Component({
  selector: 'ez-source-popover',
  templateUrl: './ez-source-popover.component.html',
  styleUrl: './ez-source-popover.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [materialModules, EzRouterLinkDirective],
})
export class EzSourcePopoverComponent {
  protected readonly sourceName = input<string>('');
  protected readonly logoUrl = input<string>();
  protected readonly sourceText = input<string>('');
  protected readonly url = input<string>('');
  protected readonly openInNew = input(false, { transform: booleanAttribute });
  protected readonly message = input<string>();
  protected readonly sourceClicked = output<void>();
  protected readonly isExternalLink = computed(() => {
    const url = this.url();
    if (!url.startsWith('http')) return false;
    try {
      return new URL(url).hostname.toLowerCase() !== window.location.hostname.toLowerCase();
    } catch {
      return false;
    }
  });
  protected readonly ezLynxLogoUrl = globalWindow.UrlResolver.MrFive('assets/images/brand-ezlynx/logo-ezlynx--red.svg');
}
